import {
    Box,
    Container,
    List,
    ListItem,
    rgbToHex,
    Typography,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import meImage from "../assets/images/me.jpeg";
import { lightBlue } from "@mui/material/colors";

function ProjectsVP(props) {
    const h4Styles = {
        color: lightBlue[200],
        marginBottom: 1,
    };

    const h5Styles = {
        color: lightBlue[100],
        marginTop: 1,
        marginBottom: 1,
    };

    const boxStyles = {
        padding: 2,
        border: `${lightBlue[50]} 1px solid`,
        borderRadius: 4,
    };

    return (
        <>
            <Container
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    // alignItems: "center",
                }}>
                <Box
                    sx={{
                        margin: 2,
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                    }}>
                    <img src={meImage} alt="Flynn" style={{ width: "70%" }} />
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 5 }}>
                    <Box>
                        <Typography variant="h4" sx={h4Styles}>
                            Flynn for Projects VP
                        </Typography>
                        <Box sx={boxStyles}>
                            <Typography variant="body">
                                Hi, I'm Flynn, a fourth-year Computer Science
                                and Mechatronic Engineering student, and I
                                currently work with Richard as a Project
                                Director for Jobsboard.
                            </Typography>
                        </Box>
                    </Box>
                    <Box>
                        <Typography variant="h4" sx={h4Styles}>
                            TL;DR
                        </Typography>
                        <Box sx={boxStyles}>
                            <ul>
                                <li>
                                    I have experience (Jobsboard Director) and
                                    Executive Experience
                                </li>
                                <li>
                                    Goals:
                                    <ul>
                                        <li>
                                            DevSoc = BNOC (Big Name on Campus)
                                        </li>
                                        <li>
                                            {" "}
                                            Analytics for Projects = More
                                            Motivation and Improved User
                                            Experience
                                        </li>
                                        <li>
                                            New Projects = Give the people what
                                            they want.
                                        </li>
                                    </ul>
                                </li>
                                <li>About Me: I like to do things</li>
                            </ul>
                        </Box>
                    </Box>
                    <Box>
                        <Typography variant="h4" sx={h4Styles}>
                            Why me?
                        </Typography>
                        <Box sx={boxStyles}>
                            <Typography variant="body">
                                Working on Jobsboard this year has given me
                                great satisfaction in developing a tool that
                                helps students in such a meaningful way. If you
                                take a quick glance at some of{" "}
                                <Link
                                    to={"/projects"}
                                    style={{ color: "unset" }}>
                                    my other personal projects
                                </Link>{" "}
                                you will see that most centre around making the
                                student life easier. Seeing people using these
                                projects is the only driving factor I need so I
                                hope to continue this passion as Projects VP to
                                propel these projects not only forward in
                                development but also into the browsers of the
                                wider UNSW community.
                            </Typography>
                        </Box>
                    </Box>
                    <Box>
                        <Typography variant="h4" sx={h4Styles}>
                            Goals and Vision
                        </Typography>

                        <Box sx={boxStyles}>
                            <Typography variant="h5" sx={h5Styles}>
                                Expanding our Reach
                            </Typography>
                            <Typography variant="body">
                                The projects are so valuable they deserve more
                                clout. With all the hard work poured into these
                                projects I want to see DevSoc become a household
                                name in the entire UNSW community ranging from
                                Fine Arts students to students stepping onto
                                main walkway for the first time. To do this
                                within the projects I will emphasize catering to
                                the needs of everyone as well as working with
                                the Marketing team to push these projects
                                further into the limelight.
                            </Typography>
                            <Typography variant="h5" sx={h5Styles}>
                                Analytics and Employability
                            </Typography>
                            <Typography variant="body">
                                I will work to integrate more analytics into the
                                DevSoc projects to allow for reporting increases
                                in usage to better understand users' needs and
                                preferences. This will also motivate Project
                                Directors to keep working on their projects when
                                they see how many people regularly rely on their
                                platforms. And furthermore, giving those hard
                                workers something concrete to talk about in
                                their job interviews such as "pushed a feature
                                to a project with over 900 users increasing
                                daily usage by 50%".
                            </Typography>
                            <Typography variant="h5" sx={h5Styles}>
                                New Projects
                            </Typography>
                            <Typography variant="body">
                                With collaboration from the Projects team I
                                intend to ignite some new DevSoc projects that
                                will further contribute to UNSW in a meaningful
                                way, while also considering the interests and
                                ideas of those who will develop them.
                            </Typography>
                        </Box>
                    </Box>
                    <Box>
                        <Typography variant="h4" sx={h4Styles}>
                            Leadership Experience
                        </Typography>

                        <Box sx={boxStyles}>
                            <Typography variant="h5" sx={h5Styles}>
                                Project Director (Jobsboard)
                            </Typography>
                            <Typography variant="body">
                                Working as Director alongside Richard taught me
                                a lot about DevSoc and managing a team. From
                                organising cross project events with Chaos, to
                                posting up tickets on GitHub Project, I've
                                gained a lot of new skills and this experience
                                makes me well suited to the role of Projects VP.
                            </Typography>

                            <Typography variant="h5" sx={h5Styles}>
                                Secretary At Basser College
                            </Typography>
                            <Typography variant="body">
                                As a member of the executive team of a
                                150-person college, I organised and presented
                                weekly meetings of the entire college as well as
                                managed and directed the rest of the leadership
                                team.
                            </Typography>
                        </Box>
                    </Box>
                    <Box>
                        <Typography variant="h4" sx={h4Styles}>
                            A Bit More About Me (if you're interested)
                        </Typography>
                        <Box sx={boxStyles}>
                            Aside from programming, my hobbies include:
                            <ul>
                                <li>
                                    Golf, which I've been playing for about 2
                                    months now
                                </li>
                                <li>
                                    Water polo, which I've been playing for
                                    about 10 years.
                                </li>
                                <li>
                                    SCUBA diving, for which I just got my
                                    licence, so I'm looking to do more.
                                </li>
                                <li>
                                    3D printing which I used to make my own
                                    custom desktop speakers.
                                </li>
                            </ul>
                            <Typography variant="h5" sx={h5Styles}>
                                How did I get here?
                            </Typography>
                            <ul>
                                <li>
                                    2021: Enrolled at UNSW in Mechanical
                                    Engineering
                                </li>
                                <li>
                                    2021 T2: Decided to figure out how to
                                    program a messenger chat bot for Basser
                                    College and self taught Python and Flask.
                                </li>
                                <li>
                                    2021 T3: Enjoyed the experience so much that
                                    I switched to Mechatronic Engineering and
                                    took COMP1511.
                                </li>
                                <li>
                                    2022: Enjoyed COMP1511 even more so did an
                                    IPT into Computer Science + Mechatronic
                                    Engineering
                                </li>
                                <li>
                                    2022: Worked through some Engineering core
                                    courses.
                                </li>
                                <li>
                                    2023: Got to do some of the key comp sci
                                    courses like COMP1521, COMP2521 and
                                    COMP2511. But most importantly COMP6080
                                    which I leveraged to construct another
                                    personal project to bolster my DevSoc
                                    Project Director Application.
                                </li>
                                <li>
                                    2023 T2: Got a taste of the SENG internship
                                    grind and difficulty finding relevant
                                    opportunities.
                                </li>
                                <li>
                                    2023 T3: Heard that DevSoc was becoming its
                                    own society and I could work on some even
                                    cooler projects than the ones I'd made
                                    myself so far, so I jumped on the
                                    application and was lucky enough to be
                                    selected as Project Director for Jobsboard.
                                </li>
                                <li>
                                    2024: Enjoyed everything about DevSoc
                                    working in my Jobsboard team and loving comp
                                    sci more than ever.
                                </li>
                            </ul>
                        </Box>
                    </Box>
                </Box>
            </Container>
        </>
    );
}

export default ProjectsVP;
